import {
  ITextField,
  ITextFieldProps as FITextFieldProps,
  ITextFieldStyles,
  TextField as FTextField,
} from '@fluentui/react';
import { forwardRef } from 'react';

import { IComponent, IconName } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { combineClassNames } from '../../utils/utils';
import { textFieldStylesDefault } from './TextField.styles';

export interface ITextFieldProps extends Omit<FITextFieldProps, 'styles'>, IComponent<ITextFieldStyles> {
  successMessage?: string;
}

export const TextField = forwardRef<ITextField, ITextFieldProps>((props, ref) => {
  const { styles, successMessage, ..._fProps } = props;
  const { errorMessage, description, className, iconProps } = props;
  const fProps: FITextFieldProps = {
    ..._fProps,
    iconProps: iconProps
      ? iconProps
      : errorMessage
      ? { iconName: IconName.StatusCircleErrorX }
      : successMessage
      ? { iconName: IconName.StatusCircleCheckmark }
      : undefined,
    styles: useThemeStyles<Partial<ITextFieldStyles>>(textFieldStylesDefault, styles),
    className: combineClassNames(className, !!errorMessage && 'has-error', !!successMessage && 'is-success'),
    description: description || successMessage,
  };
  return <FTextField {...fProps} componentRef={ref as any} data-test={props['data-test'] || 'text-field'} />;
});
